export default __webpack_public_path__ + "images/bfde4eeb1720f26371b3680873cceaa1.gif";